import React from 'react'

export const DropDownIcon = () => {
  return (
    <svg id="svg-close" xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="2 0 25 25">
      <path d="m7 10 5 5 5-5z"></path>
    </svg>
  )
}
